import React from "react"

import GridSectionTitles from "./GridSectionTitles"
import SliderSectionTitle from "./SliderSectionTitle"
import { Color } from "../../../constants/V2/color"

type Props = {
  sectionId: string
  size: "small" | "large"
  headingSecondaryText?: string
  headingSecondaryColor: Color
  headingPrimaryText: string
  headingPrimaryColor: Color
  showSliderHeading: boolean
  alignment?: "center" | "left"
}

const TableSectionTitles = ({
  sectionId,
  size,
  headingSecondaryText,
  headingSecondaryColor,
  headingPrimaryText,
  headingPrimaryColor,
  showSliderHeading,
  alignment = "center",
}: Props) => {
  if (showSliderHeading) {
    return (
      <SliderSectionTitle
        sectionId={sectionId}
        size={size}
        headingText={headingPrimaryText}
        subheadingText={headingSecondaryText}
        color={headingPrimaryColor}
      />
    )
  }
  return (
    <GridSectionTitles
      alignment={alignment}
      size={size}
      headingText={headingPrimaryText}
      headingTextColor={headingPrimaryColor}
      headingBodyText={headingSecondaryText}
      headingBodyColor={headingSecondaryColor}
      superscriptColor={headingSecondaryColor}
    />
  )
}

export default TableSectionTitles
